
import { useState, useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import TestimonialsHero from './components/TestimonialsHero';
import TestimonialsGrid from './components/TestimonialsGrid';
import TestimonialsStats from './components/TestimonialsStats';
import TestimonialsCTA from './components/TestimonialsCTA';
import ReviewUsSection from './components/ReviewUsSection';
import { useSEO, generateWebPageSchema, generateBreadcrumbSchema, generateTestimonialsSchema } from '../../utils/seo';

const REVIEWS = [
  { author: 'Sarah M.', rating: 5, text: 'Brushour transformed our living room completely. Exceptional attention to detail and a spotless finish. Highly recommend for any painting work in Watford.', date: '2025-03-10' },
  { author: 'James T.', rating: 5, text: 'Used Brushour for exterior painting on our Hertfordshire home. Professional, punctual, and the results are outstanding. Will definitely use again.', date: '2025-02-18' },
  { author: 'Emma R.', rating: 5, text: 'Fantastic wallpaper installation service. Daniel and the team were tidy, efficient, and the finish is perfect. Best decorators in Watford.', date: '2025-01-25' },
  { author: 'Michael B.', rating: 5, text: 'Brushour painted our entire office in Hertfordshire. Minimal disruption, great communication, and a superb result. Highly professional team.', date: '2024-12-14' },
  { author: 'Claire W.', rating: 5, text: 'Incredible transformation of our kitchen. The cabinet painting is flawless. Brushour are truly the best painters and decorators in the area.', date: '2024-11-30' },
  { author: 'David H.', rating: 5, text: 'From quote to completion, the whole experience was seamless. Brushour delivered exactly what was promised – beautiful painting throughout our Watford home.', date: '2024-10-22' },
];

export default function TestimonialsPage() {
  const [scrolled, setScrolled] = useState(false);
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Customer Reviews | Brushour Painters & Decorators Watford',
    description: 'Read 500+ verified reviews from satisfied customers of Brushour painters and decorators in Watford, Hertfordshire. 5-star rated painting and decorating services across Hertfordshire.',
    keywords: 'painter reviews Watford, decorator testimonials Hertfordshire, customer reviews painting Watford, 5 star painters Hertfordshire, Brushour reviews',
    canonical: `${SITE_URL}/testimonials`,
    ogImage: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/e6c157647967ffb5fa62a9e4cb4fe039.png',
    schema: [
      generateTestimonialsSchema(REVIEWS),
      generateWebPageSchema('Customer Reviews – Brushour Painters & Decorators Watford', 'Read verified reviews from 500+ satisfied customers of Brushour painting and decorating services', `${SITE_URL}/testimonials`),
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'Testimonials', url: `${SITE_URL}/testimonials` },
      ]),
    ],
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation scrolled={scrolled} />
      <TestimonialsHero />
      <TestimonialsStats />
      <TestimonialsGrid />
      <ReviewUsSection />
      <TestimonialsCTA />
      <Footer />
    </div>
  );
}
